<template>
  <div class="accordions__container">
    <div v-bind:key="index" v-for="(value, title, index) in vaccineOptions">
      <h3 class="accordion-sub-heading" v-if="accordionMapBefore[index] !== null && index === 0">{{ childName ? replaceName(locale('Vaccines.AlreadyHas1-1')) :locale('Vaccines.AlreadyHas1-1') }}</h3>
      <ontario-accordion
        v-if="accordionMapBefore[index] !== null "
        class="accordion"
        :openedAccordions="openedAccordions"
        :accordion-array="[accordionMapBefore[index]]"
      >
        <template>
          <p>{{ childName ? replaceName(locale('Vaccines.AlreadyHas1-2')) : locale('Vaccines.AlreadyHas1-2') }}</p>
          <div v-for="(vaccines, index) in value" :key="index">
            <ul class="accordion__list">
              <li v-html="vaccines"/>
            </ul>
          </div>
        </template>
      </ontario-accordion>

      <h3 class="accordion-sub-heading" v-if="accordionMapBefore[index] == null && accordionMapBefore[index - 1] !== null && accordionMapAfter[index]" >{{ childName ? replaceName(locale('Vaccines.NeedsTo1-1')) : locale('Vaccines.NeedsTo1-1') }}</h3>
      <ontario-accordion
        v-if="accordionMapAfter[index] !== null"
        class="accordion"
        :startingOpenedAccordions="index"
        :accordion-array="[accordionMapAfter[index]]"
      >
        <template>
          <p>{{ childName ? replaceName(locale('Vaccines.NeedsTo1-2')) : locale('Vaccines.NeedsTo1-2') }}</p>
          <div v-for="(vaccines, index) in value" :key="index">
            <ul class="accordion__list">
              <li v-html="vaccines"/>
            </ul>
          </div>
        </template>
      </ontario-accordion>
      <p v-if="index == accordionMapAfter.length - 1" v-html="locale('Vaccines.AtSchool')"> </p>
    </div>
  </div>
</template>

<script>
import drupal from '../../../shared/mixins/drupal';
import Accordion from '../../../shared/components/Accordion';
import AccordionItem from '../../../shared/functions/AccordionItem';
import i18n from '../i18n';
import { printJson, createCalendar, dateAfterJune2021, monthsAdd, splitVaccinations } from '../functions/appFunctions';

export default {
  name: 'resultAccordions',
  mixins: [drupal],
  props: {
    birthday: String,
    childName: String
  },
  watch: {
    birthday: function (value) {
      this.splitLists = splitVaccinations(value, this.localeObjectArray('Vaccines.Timelines'));
      this.setOpenedAccordions(this.splitLists[1]);
    }
  },
  components: {
    OntarioAccordion: Accordion
  },
  data() {
    return {
      openedAccordions: [],
      splitLists: [[],[]],
    }
  },
  computed: {
      // List of vaccines the child should already have using the results of splitVaccinations.
      accordionMapBefore() {
        return this.localeObjectArray('Vaccines.Timelines').map((entity, index) => (this.splitLists[0].includes(index) && entity) ? AccordionItem(index, entity.displayValue + " (" + monthsAdd(this.birthday, entity.value) + ")") : null);
      },
      // List of vaccines the child needs to get using the results of splitVaccinations
      accordionMapAfter() {
        return this.localeObjectArray('Vaccines.Timelines').map((entity, index) => (this.splitLists[1].includes(index)&& entity) ? AccordionItem(index, entity.displayValue + " (" + monthsAdd(this.birthday, entity.value) + ")") : null);
      },
      vaccineOptions() {
        return dateAfterJune2021(this.birthday) ? this.locale('Vaccines.OptionsRotavirus') : this.locale('Vaccines.Options');
      }
  },
  methods: {
    setOpenedAccordions(list) {
      this.openedAccordions = list;
      this.$emit('print', printJson(this.localeObjectArray('Vaccines.Timelines').map((entity, index) => this.splitLists[1].includes(index) ? monthsAdd(this.birthday, entity.value) : null), this.birthday));
      this.$emit('create', createCalendar(this.localeObjectArray('Vaccines.Timelines').map((entity, index) => this.splitLists[1].includes(index) ? monthsAdd(this.birthday, entity.value) : null), this.childName, this.birthday));
    },
    replaceName(string) {
      if (i18n.locale == 'en') {
        string = string.replace('Your child', this.childName).replace('your child', this.childName);
      } else if (i18n.locale == 'fr') {
        string = string.replace('Votre enfant', this.childName).replace('votre enfant', this.childName);
      }
      return string;
    }
  },
}
</script>

<style lang="scss">
  .accordion {
    max-width: 768px;
  }
  @media only screen and (max-width: 480px) {
    ul {
      width: 100%;
    }
  }
  ul li div div ol {
    list-style-type: circle !important;
    display: list-item;
    list-style-position: inside;
  }

  .accordions__container {
    margin-bottom: 2rem;
  }

  .accordions__container .accordion-sub-heading {
    margin-top: 2rem !important;
    margin-bottom: 1rem;
    max-width: 48rem;
  }

  .accordion-sub-heading {
    max-width: 48rem;
  }
</style>
